const UserIconAlt = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.56 5.94a9 9 0 1 1-12.12 0 9 9 0 0 1 12.12 0Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.31 17.74c1.74-1.78 3.62-2.88 6.22-2.88s4.42 1.08 6.16 2.83c-1.74 1.79-3.63 2.89-6.22 2.89-2.56 0-4.42-1.08-6.16-2.83Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.52 7.12a3 3 0 1 1-4.04 0 3 3 0 0 1 4.04 0Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UserIconAlt;
